import { Button } from '@mui/material';
import { Sketch } from '@uiw/react-color';
import React, { useState } from 'react';
import { TextInput, required } from 'react-admin';
import { useFormContext, useWatch } from 'react-hook-form';

const ColorPicker = (props) => {
  const { label, source } = props;

  // Para pegar o form desse componente
  const { setValue } = useFormContext();

  const dado = useWatch({ name: `${source}` });

  const [visible, setVisible] = useState(false);
  const [color, setColor] = useState(dado || '');

  return (
    <>
      <div>
        <TextInput
          validate={required()}
          label={label}
          source={source}
          value={color}
        />
        <Button
          onClick={() => {
            setVisible(!visible);
          }}
          variant="outlined"
          style={{ marginTop: '14px', marginLeft: '5px' }}
        >
          +
        </Button>
      </div>

      <div style={{ display: visible ? 'block' : 'none' }}>
        <Sketch
          color={color}
          onChange={(resultado) => {
            setColor(resultado.hex);
            setValue(source, resultado.hex);
          }}
        />
      </div>
    </>
  );
};
export default ColorPicker;
